import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import apiReducer from './apiReducer';
import widgetReducer from './widgetReducer';
import searchReducer from './searchReducer';

const reducers = combineReducers({
	api: apiReducer,
	widgets: widgetReducer,
	routing: routerReducer,
	search: searchReducer
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js